import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { createContext, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import config from "../../config"; // Components
// import Button from "react-property-app/components/Button";

import Icon from "../Icon";
import "./EnquiryForm.scss";
export var EnquiryFormContext = createContext();

var EnquiryFormModal = function EnquiryFormModal(a) {
  var b = a.pkg,
      c = a.toggle;

  if (b) {
    var d = config.enquiryForm.get("type"),
        e = config.enquiryForm.get("function");
    if ("custom_function" === d || "function" == typeof e) return null;
    var f = b.name,
        g = b.url,
        h = b.id || b.lot_id,
        i = window.location.origin + g,
        j = config.enquiryForm.get("tfa_ids") || [],
        k = j.find(function (a) {
      var c = a.split("$"),
          d = _slicedToArray(c, 1),
          e = d[0];

      return !!(-1 < b.slug.indexOf(e) || b.neighbourhood_slug === e || b.project_slug === e || b.release_slug === e);
    }),
        l = config.enquiryForm.get("tfa_id");
    return k && (l = k.split("$")[1]), ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
      className: "enquiryform"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ta-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "enquiryform--content"
    }, /*#__PURE__*/React.createElement(Icon, {
      onClick: c,
      icon: "close_black",
      className: "close"
    }), /*#__PURE__*/React.createElement("h3", null, "Register your interest"), /*#__PURE__*/React.createElement("h2", null, "Find out more information on", /*#__PURE__*/React.createElement("span", null, f)), /*#__PURE__*/React.createElement("iframe", {
      src: "https://tfaforms.com/".concat(l, "?tfa_21=").concat(i, "&tfa_55=").concat(h),
      height: "450",
      width: "100%",
      frameBorder: "0",
      title: "enquiry"
    }), /*#__PURE__*/React.createElement("script", {
      src: "//tfaforms.com/js/iframe_resize_helper.js"
    }))))), document.body);
  }

  return null;
};

export var EnquiryForm = function EnquiryForm(a) {
  var b = a.children,
      c = useState(),
      d = _slicedToArray(c, 2),
      e = d[0],
      f = d[1],
      g = function g(a) {
    f(e ? null : a);
    var b = config.enquiryForm.get("type"),
        c = config.enquiryForm.get("function");

    if ("custom_function" === b || "function" == typeof c) {
      var d = config.enquiryForm.get("function_name");
      d && (d = d.replace("()", ""));
      var g = c || window.get(d);
      if ("function" == typeof g) return g(a);
    }
  };

  return useEffect(function () {
    e && !document.body.classList.contains("ta-overflow") ? document.body.classList.toggle("ta-overflow") : !e && document.body.classList.contains("ta-overflow") && document.body.classList.toggle("ta-overflow");
  }, [e]), /*#__PURE__*/React.createElement(EnquiryFormContext.Provider, {
    value: g
  }, /*#__PURE__*/React.createElement(React.Fragment, null, b, /*#__PURE__*/React.createElement(EnquiryFormModal, {
    pkg: e,
    toggle: g
  })));
};
export default EnquiryForm;